import React, { type ReactNode } from 'react';

import './_CenteredContentSpaceBetween.scss';

interface CenteredContentSpaceBetweenProps {
    children: ReactNode;
    excludePaddingTop?: boolean;
    transparentBackground?: boolean;
}

const CenteredContentSpaceBetween = ({
    children,
    excludePaddingTop,
    transparentBackground,
}: CenteredContentSpaceBetweenProps) => {
    return (
        <div
            className={`centered-content-space-between ${
                excludePaddingTop && 'centered-content-space-between--no-pad'
            } ${transparentBackground && 'transparent'}`}
        >
            {children}
        </div>
    );
};

export default CenteredContentSpaceBetween;
